// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("images/ui-icons_222222_256x240.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* This stylesheet provides the structural CSS for the dgrid */
.dgrid {
	position: relative;
	overflow: hidden; /* This is needed by IE to prevent crazy scrollbar flashing */
	border: 1px solid #ddd;
	height: 30em;
	display: block;
}

.dgrid-header {
	background-color: #eee;
}

.dgrid-header-row {
	position: absolute;
	right: 17px; /* scrollbar width; revised in List.js if necessary */
	left: 0;
}

.dgrid-header-scroll {
	position: absolute;
	top: 0;
	right: 0;
}

.dgrid-footer {
	position: absolute;
	bottom: 0;
	width: 100%;
}

.dgrid-header-hidden,
html.has-quirks .dgrid-header-hidden .dgrid-cell {
	/*
		Used to "hide" header, without losing size information for reference.
		!important is used to supersede theme styles at higher specificity.
		Left/right box styles are untouched, as they may influence width of
		.dgrid-content as updated in Grid's resize method.
		Note: Still not quite perfect in IE Quirks mode (1px left over).
	*/
	font-size: 0; /* allow shrinkage in IE Quirks mode for Lists */
	height: 0 !important;
	border-top: none !important;
	border-bottom: none !important;
	margin-top: 0 !important;
	margin-bottom: 0 !important;
	padding-top: 0 !important;
	padding-bottom: 0 !important;
}

.dgrid-footer-hidden {
	/* Hiding footer is much simpler; simply set its display to none. */
	display: none;
}

.dgrid-sortable {
	cursor: pointer;
}
.dgrid-header, .dgrid-header-row, .dgrid-footer {
	overflow: hidden;
	background-color: #eee;
}

.dgrid-row-table {
	border-collapse: collapse;
	border: none;
	table-layout: fixed;
	empty-cells: show;
	width: 100%; /* this becomes 'auto' for IE7 (non-quirks) */
	height: 100%;
}
.dgrid-cell {
	padding: 0px;
	text-align: left;
	overflow: hidden;
	vertical-align: top;
	border: 1px solid #ddd;
	border-top-style: none;
	
	box-sizing: border-box;
	-moz-box-sizing: border-box;
	-ms-box-sizing: border-box;
	-webkit-box-sizing: border-box;
}
.dgrid-cell-padding {
	padding: 3px;
}

.dgrid-content {
	position: relative;
	height: 99%;
}

.dgrid-scroller {
	overflow-x: auto;
	overflow-y: scroll;
	position: absolute;
	top: 0px;
	margin-top: 25px; /* this will be adjusted programmatically to fit below the header*/
	bottom: 0px;
	width: 100%;
}

.dgrid-preload {
	/* Force IE6 to honor 0 height */
	font-size: 0;
	line-height: 0;
}

.dgrid-loading {
	position: relative;
	height: 100%;
}
.dgrid-above {
	position: absolute;
	bottom: 0;
}

.ui-icon {
	width: 16px;
	height: 16px;
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.ui-icon-triangle-1-e {
	background-position: -32px -16px;
}
.ui-icon-triangle-1-se {
	background-position: -48px -16px;
}

.dgrid-expando-icon {
	width: 16px;
	height: 16px;
}
.dgrid-tree-container {
	-webkit-transition-duration: 0.3s;
	-moz-transition-duration: 0.3s;
	-ms-transition-duration: 0.3s;
	-o-transition-duration: 0.3s;
	transition-duration: 0.3s;
	overflow: hidden;
}
.dgrid-tree-container.dgrid-tree-resetting {
	-webkit-transition-duration: 0;
	-moz-transition-duration: 0;
	-ms-transition-duration: 0;
	-o-transition-duration: 0;
	transition-duration: 0;
}

/* Single Sort */
.dgrid-sort-arrow {
	background-position: -64px -16px;
	display: block;
	float: right;
	margin: 0 4px 0 5px;
	height: 12px;
}
.dgrid-sort-up .dgrid-sort-arrow {
	background-position: 0px -16px;
}

/* selection*/
.dgrid-selected {
	background-color: #bfd6eb;
}

.dgrid-input {
	width: 99%;
}

/* UA-specific hacks*/
html.has-mozilla .dgrid *:focus, html.has-opera .dgrid *:focus {
	/* firefox's focus doesn't work by default for divs prior to actually tabbing into it. This fixes that
	(we don't do any other browsers because we are trying to stay as close to native as possible) */ 
	outline: 1px dotted;
}
html.has-ie-6-7.has-no-quirks .dgrid-row-table {
	/* in IE7 this is needed instead of 100% to make it not create a horizontal scroll bar*/
	width: auto;
}
html.has-quirks .dgrid-row-table, html.has-ie-6 .dgrid-row-table {
	/* similar story, height looks too high */
	height: auto; 
}

html.has-quirks .dgrid-header-scroll,
html.has-ie-6 .dgrid-header-scroll {
	/* ensure that header scroll node can shrink to 0 height in IE6 & quirks */
	font-size: 0;
}

html.has-mozilla .dgrid-focus {
	/* fix row focus outline (prevents horizontal scroll in FF 3.6) */
	outline-offset: -1px;
}

/* will be used to calculate the width of the scrollbar */
.dgrid-scrollbar-measure {
	width: 100px;
	height: 100px;
	overflow: scroll;
	position: absolute;
	top: -9999px;
}

/* Styles for auto-height grids; simply add the dgrid-autoheight class */
.dgrid-autoheight {
	height: auto;
}
.dgrid-autoheight .dgrid-scroller {
	position: relative;
	overflow-y: hidden;
}
.dgrid-autoheight .dgrid-header-scroll {
	display: none;
}
.dgrid-autoheight .dgrid-header {
	right: 0;
}

/* indicator of a successful load */
#dgrid-css-dgrid-loaded {
	display: none;
}`, "",{"version":3,"sources":["webpack://./target/debug/2P/derived/ui/dgrid/css/dgrid.css"],"names":[],"mappings":"AAAA,8DAA8D;AAC9D;CACC,kBAAkB;CAClB,gBAAgB,EAAE,6DAA6D;CAC/E,sBAAsB;CACtB,YAAY;CACZ,cAAc;AACf;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,kBAAkB;CAClB,WAAW,EAAE,qDAAqD;CAClE,OAAO;AACR;;AAEA;CACC,kBAAkB;CAClB,MAAM;CACN,QAAQ;AACT;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,WAAW;AACZ;;AAEA;;CAEC;;;;;;EAMC;CACD,YAAY,EAAE,gDAAgD;CAC9D,oBAAoB;CACpB,2BAA2B;CAC3B,8BAA8B;CAC9B,wBAAwB;CACxB,2BAA2B;CAC3B,yBAAyB;CACzB,4BAA4B;AAC7B;;AAEA;CACC,mEAAmE;CACnE,aAAa;AACd;;AAEA;CACC,eAAe;AAChB;AACA;CACC,gBAAgB;CAChB,sBAAsB;AACvB;;AAEA;CACC,yBAAyB;CACzB,YAAY;CACZ,mBAAmB;CACnB,iBAAiB;CACjB,WAAW,EAAE,6CAA6C;CAC1D,YAAY;AACb;AACA;CACC,YAAY;CACZ,gBAAgB;CAChB,gBAAgB;CAChB,mBAAmB;CACnB,sBAAsB;CACtB,sBAAsB;;CAEtB,sBAAsB;CACtB,2BAA2B;CAC3B,0BAA0B;CAC1B,8BAA8B;AAC/B;AACA;CACC,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,WAAW;AACZ;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;CAClB,kBAAkB;CAClB,QAAQ;CACR,gBAAgB,EAAE,kEAAkE;CACpF,WAAW;CACX,WAAW;AACZ;;AAEA;CACC,gCAAgC;CAChC,YAAY;CACZ,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,YAAY;AACb;AACA;CACC,kBAAkB;CAClB,SAAS;AACV;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,yDAA2D;AAC5D;;AAEA;CACC,gCAAgC;AACjC;AACA;CACC,gCAAgC;AACjC;;AAEA;CACC,WAAW;CACX,YAAY;AACb;AACA;CACC,iCAAiC;CACjC,8BAA8B;CAC9B,6BAA6B;CAC7B,4BAA4B;CAC5B,yBAAyB;CACzB,gBAAgB;AACjB;AACA;CACC,8BAA8B;CAC9B,2BAA2B;CAC3B,0BAA0B;CAC1B,yBAAyB;CACzB,sBAAsB;AACvB;;AAEA,gBAAgB;AAChB;CACC,gCAAgC;CAChC,cAAc;CACd,YAAY;CACZ,mBAAmB;CACnB,YAAY;AACb;AACA;CACC,8BAA8B;AAC/B;;AAEA,aAAa;AACb;CACC,yBAAyB;AAC1B;;AAEA;CACC,UAAU;AACX;;AAEA,qBAAqB;AACrB;CACC;gGAC+F;CAC/F,mBAAmB;AACpB;AACA;CACC,uFAAuF;CACvF,WAAW;AACZ;AACA;CACC,yCAAyC;CACzC,YAAY;AACb;;AAEA;;CAEC,0EAA0E;CAC1E,YAAY;AACb;;AAEA;CACC,iEAAiE;CACjE,oBAAoB;AACrB;;AAEA,yDAAyD;AACzD;CACC,YAAY;CACZ,aAAa;CACb,gBAAgB;CAChB,kBAAkB;CAClB,YAAY;AACb;;AAEA,wEAAwE;AACxE;CACC,YAAY;AACb;AACA;CACC,kBAAkB;CAClB,kBAAkB;AACnB;AACA;CACC,aAAa;AACd;AACA;CACC,QAAQ;AACT;;AAEA,mCAAmC;AACnC;CACC,aAAa;AACd","sourcesContent":["/* This stylesheet provides the structural CSS for the dgrid */\n.dgrid {\n\tposition: relative;\n\toverflow: hidden; /* This is needed by IE to prevent crazy scrollbar flashing */\n\tborder: 1px solid #ddd;\n\theight: 30em;\n\tdisplay: block;\n}\n\n.dgrid-header {\n\tbackground-color: #eee;\n}\n\n.dgrid-header-row {\n\tposition: absolute;\n\tright: 17px; /* scrollbar width; revised in List.js if necessary */\n\tleft: 0;\n}\n\n.dgrid-header-scroll {\n\tposition: absolute;\n\ttop: 0;\n\tright: 0;\n}\n\n.dgrid-footer {\n\tposition: absolute;\n\tbottom: 0;\n\twidth: 100%;\n}\n\n.dgrid-header-hidden,\nhtml.has-quirks .dgrid-header-hidden .dgrid-cell {\n\t/*\n\t\tUsed to \"hide\" header, without losing size information for reference.\n\t\t!important is used to supersede theme styles at higher specificity.\n\t\tLeft/right box styles are untouched, as they may influence width of\n\t\t.dgrid-content as updated in Grid's resize method.\n\t\tNote: Still not quite perfect in IE Quirks mode (1px left over).\n\t*/\n\tfont-size: 0; /* allow shrinkage in IE Quirks mode for Lists */\n\theight: 0 !important;\n\tborder-top: none !important;\n\tborder-bottom: none !important;\n\tmargin-top: 0 !important;\n\tmargin-bottom: 0 !important;\n\tpadding-top: 0 !important;\n\tpadding-bottom: 0 !important;\n}\n\n.dgrid-footer-hidden {\n\t/* Hiding footer is much simpler; simply set its display to none. */\n\tdisplay: none;\n}\n\n.dgrid-sortable {\n\tcursor: pointer;\n}\n.dgrid-header, .dgrid-header-row, .dgrid-footer {\n\toverflow: hidden;\n\tbackground-color: #eee;\n}\n\n.dgrid-row-table {\n\tborder-collapse: collapse;\n\tborder: none;\n\ttable-layout: fixed;\n\tempty-cells: show;\n\twidth: 100%; /* this becomes 'auto' for IE7 (non-quirks) */\n\theight: 100%;\n}\n.dgrid-cell {\n\tpadding: 0px;\n\ttext-align: left;\n\toverflow: hidden;\n\tvertical-align: top;\n\tborder: 1px solid #ddd;\n\tborder-top-style: none;\n\t\n\tbox-sizing: border-box;\n\t-moz-box-sizing: border-box;\n\t-ms-box-sizing: border-box;\n\t-webkit-box-sizing: border-box;\n}\n.dgrid-cell-padding {\n\tpadding: 3px;\n}\n\n.dgrid-content {\n\tposition: relative;\n\theight: 99%;\n}\n\n.dgrid-scroller {\n\toverflow-x: auto;\n\toverflow-y: scroll;\n\tposition: absolute;\n\ttop: 0px;\n\tmargin-top: 25px; /* this will be adjusted programmatically to fit below the header*/\n\tbottom: 0px;\n\twidth: 100%;\n}\n\n.dgrid-preload {\n\t/* Force IE6 to honor 0 height */\n\tfont-size: 0;\n\tline-height: 0;\n}\n\n.dgrid-loading {\n\tposition: relative;\n\theight: 100%;\n}\n.dgrid-above {\n\tposition: absolute;\n\tbottom: 0;\n}\n\n.ui-icon {\n\twidth: 16px;\n\theight: 16px;\n\tbackground-image: url('images/ui-icons_222222_256x240.png');\n}\n\n.ui-icon-triangle-1-e {\n\tbackground-position: -32px -16px;\n}\n.ui-icon-triangle-1-se {\n\tbackground-position: -48px -16px;\n}\n\n.dgrid-expando-icon {\n\twidth: 16px;\n\theight: 16px;\n}\n.dgrid-tree-container {\n\t-webkit-transition-duration: 0.3s;\n\t-moz-transition-duration: 0.3s;\n\t-ms-transition-duration: 0.3s;\n\t-o-transition-duration: 0.3s;\n\ttransition-duration: 0.3s;\n\toverflow: hidden;\n}\n.dgrid-tree-container.dgrid-tree-resetting {\n\t-webkit-transition-duration: 0;\n\t-moz-transition-duration: 0;\n\t-ms-transition-duration: 0;\n\t-o-transition-duration: 0;\n\ttransition-duration: 0;\n}\n\n/* Single Sort */\n.dgrid-sort-arrow {\n\tbackground-position: -64px -16px;\n\tdisplay: block;\n\tfloat: right;\n\tmargin: 0 4px 0 5px;\n\theight: 12px;\n}\n.dgrid-sort-up .dgrid-sort-arrow {\n\tbackground-position: 0px -16px;\n}\n\n/* selection*/\n.dgrid-selected {\n\tbackground-color: #bfd6eb;\n}\n\n.dgrid-input {\n\twidth: 99%;\n}\n\n/* UA-specific hacks*/\nhtml.has-mozilla .dgrid *:focus, html.has-opera .dgrid *:focus {\n\t/* firefox's focus doesn't work by default for divs prior to actually tabbing into it. This fixes that\n\t(we don't do any other browsers because we are trying to stay as close to native as possible) */ \n\toutline: 1px dotted;\n}\nhtml.has-ie-6-7.has-no-quirks .dgrid-row-table {\n\t/* in IE7 this is needed instead of 100% to make it not create a horizontal scroll bar*/\n\twidth: auto;\n}\nhtml.has-quirks .dgrid-row-table, html.has-ie-6 .dgrid-row-table {\n\t/* similar story, height looks too high */\n\theight: auto; \n}\n\nhtml.has-quirks .dgrid-header-scroll,\nhtml.has-ie-6 .dgrid-header-scroll {\n\t/* ensure that header scroll node can shrink to 0 height in IE6 & quirks */\n\tfont-size: 0;\n}\n\nhtml.has-mozilla .dgrid-focus {\n\t/* fix row focus outline (prevents horizontal scroll in FF 3.6) */\n\toutline-offset: -1px;\n}\n\n/* will be used to calculate the width of the scrollbar */\n.dgrid-scrollbar-measure {\n\twidth: 100px;\n\theight: 100px;\n\toverflow: scroll;\n\tposition: absolute;\n\ttop: -9999px;\n}\n\n/* Styles for auto-height grids; simply add the dgrid-autoheight class */\n.dgrid-autoheight {\n\theight: auto;\n}\n.dgrid-autoheight .dgrid-scroller {\n\tposition: relative;\n\toverflow-y: hidden;\n}\n.dgrid-autoheight .dgrid-header-scroll {\n\tdisplay: none;\n}\n.dgrid-autoheight .dgrid-header {\n\tright: 0;\n}\n\n/* indicator of a successful load */\n#dgrid-css-dgrid-loaded {\n\tdisplay: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
